import React,{useEffect,useState} from 'react';
// ,useContext
//import ReactTooltip from 'react-tooltip';
import { InputGroup, Container, Row, Col, Modal, Button, Form, Nav } from 'react-bootstrap';
// , Tabs, Tab, Dropdown, DropdownButton, SplitButton, FormCheck, FormControl,
// import { org_uuid, user_entity_uuid, apiUrl, searchUrl, myHeaders_Auth_With_Cache_Control } from "Api/Api";
import { grabFromLocalStorage, user_Registration, user_authentication } from 'Api/Api';
// , twitter_api, facebook_get_access_token_api, HeaderConfig
import { local_routes } from "utils/Routes";

import { saveKey } from "utils/Helper";

//import { HubspotForm } from "Api/HubspotApi.js";

import axios from "axios";

//import Select from 'react-select';

//import geoLocation from 'utils/geoLocation';

//import UserContext from 'store/UserContext';

//import { slugify } from 'utils/Helper';

//import { useForm } from 'react-hubspot'

import Facebook from 'containers/SocialLogin/Facebook/Facebook';
import Twitter from 'containers/SocialLogin/Twitter/Twitter';
import LinkedIn from 'containers/SocialLogin/LinkedIn/LinkedIn';
import Google from 'containers/SocialLogin/Google/Google';

import ActivityIndicator from 'components/ActivityIndicator/ActivityIndicator';


import './style.css';

function SignupModal (props) {
  //console.log("OnboardingModal constructor",props);

  const [email_password_validated, setEmailPasswordValidated] = useState(false);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState(<span>&nbsp;</span>);
  const [password_field_options, setPasswordFieldOptions] = useState({field_type:'password',visibility_icon:<i className="fa fa-eye"></i>})
  const [tab_choice, setTabChoice] = useState('signup'); // or register
 
  const tab_messaging = {
    login: {
      title: "Login to PechaKucha.com",
      button_text: "Log In",
      toggle_text: "I have an account"
    },
    signup: {
      title: "Register for PechaKucha.com",
      button_text: "Join the Community",
      toggle_text: "I'm new"
    }
  }

  // on mount
  useEffect(() => {
    console.log("SignupModal useEffect props.show");
    setLoading(false);
  }, [props.show]);

  async function loginOrSignup (event) {
        const form = event.currentTarget;
        event.preventDefault();
        if (form.checkValidity() === false) {
            //event.preventDefault();
            event.stopPropagation();
            console.log("NOOOOO");
            //return;
        } else {
          setLoading(true);
          setMessage(<span style={{ color: "darkgray" }}>Working...</span>);
          let loginData = { "email": email, "password": password }
          
          if (tab_choice === 'signup') {
              try {
                let response = await axios.post(user_Registration, loginData);
                let UserData = { "UserMail": email, "login_Auth_Res": response.data, }
                saveKey("UserData", JSON.stringify(UserData));
                grabFromLocalStorage();
                if (props.reload) {
                  window.scrollTo(0, 0);
                  window.location.reload();
                } else {
                  window.scrollTo(0, 0);
                  window.location.href = '/';
                }
              } catch (err) {
                // we should now try to login...lower friction for users
                try {
                  let response = await axios.post(user_authentication, loginData);
                  let UserData = { "UserMail": email, "login_Auth_Res": response.data, }
                  saveKey("UserData", JSON.stringify(UserData));
                  grabFromLocalStorage();
                  if (props.reload) {
                    window.scrollTo(0, 0);
                    window.location.reload();
                  } else {
                    window.scrollTo(0, 0);
                    window.location.href = '/';
                  }
                } catch (err) {
                  setLoading(false);
                  setMessage(<span style={{ color: "red" }}>Invalid Username/Password</span>);
                }
                
                //setLoading(false);
                //setMessage(<span style={{ color: "red" }}>Invalid Username/Password</span>);
              }
          } else if (tab_choice === 'login') {
              try {
                let response = await axios.post(user_authentication, loginData);
                let UserData = { "UserMail": email, "login_Auth_Res": response.data, }
                saveKey("UserData", JSON.stringify(UserData));
                grabFromLocalStorage();
                if (props.reload) {
                  window.location.reload();
                } else {
                  window.location.href = '/';
                }
              } catch (err) {
                setLoading(false);
                setMessage(<span style={{ color: "red" }}>Invalid Username/Password</span>);
              }
          }
        }
        setEmailPasswordValidated(true);
    }

    function myChangeHandler (event) {
        if (event.target.id === "validationEmail") {
          setEmail(event.target.value);
        }
        else if (event.target.id === "validationPassword") {
          setPassword(event.target.value);
        }
    }

    // changeState is for password toggle validation.
    function changePasswordVisibility () {
        var oldState = password_field_options.field_type;
        var isTextOrHide = (oldState === 'password');
        var newState = (isTextOrHide) ? 'text' : 'password';
        var newWord = (isTextOrHide) ? <i className="fa fa-eye-slash" aria-hidden="true"></i> : <i className="fa fa-eye"></i>;
        setPasswordFieldOptions({field_type:newState,visibility_icon:newWord});
    }
    
    function changeTab (eventKey) {
      if (eventKey !== tab_choice) {
        setMessage(<span>&nbsp;</span>);
      }
      setTabChoice(eventKey);
    }
  
  return (
    <Modal
      style={{ color: 'black' }}
      show={props.show}
      onHide={props.onHide}
      //{...props}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          <p style={{ textAlign: 'center' }}>{tab_choice === 'signup' ? 'Sign-Up!' : 'Log In'}</p>
          {/*{tab_messaging[tab_choice].title}*/}
          <p style={{ textAlign: 'center', fontSize: "60%", color: "darkgray" }}>Watch thousands of PechaKucha presentations and get access to PK Create Basic for free.</p>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        
        <Container>
          <Row>
            <Col>
            <Nav justify variant="tabs" activeKey={tab_choice} onSelect={(k) => changeTab(k)}>
              <Nav.Item>
                <Nav.Link eventKey="signup">Sign Up</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="login">Log In</Nav.Link>
              </Nav.Item>
            </Nav>
            </Col>
          </Row>
          {/*
          <Row>
            <hr className="w-100"/>
          </Row>
          */}
          <Row className="mt-2">
            <Col xs="12" sm="7">
                  <Form noValidate validated={email_password_validated} onSubmit={loginOrSignup}>
                    <fieldset disabled={loading}>
                    <Form.Row>
                      <Form.Group as={Col} controlId="validationEmail">
                          <Form.Label>E-MAIL ADDRESS</Form.Label>
                          <Form.Control
                              required
                              type="email"
                              placeholder="Enter your email"
                              onChange={myChangeHandler}
                          />
                      </Form.Group>
                    </Form.Row>
                    <Form.Row>
                      <Form.Group as={Col} controlId="validationPassword">
                          <Form.Label>PASSWORD</Form.Label>
                          <InputGroup>
                            <Form.Control
                                type={password_field_options.field_type}
                                placeholder="Enter your password"
                                aria-describedby="inputGroupPrepend"
                                required
                                onChange={myChangeHandler}
                            />
                            <span className="password-trigger" onClick={changePasswordVisibility}>{password_field_options.visibility_icon}</span>
                          </InputGroup>
                      </Form.Group>
                    </Form.Row>
                  
              { tab_choice === 'login' ?
                <Row className="">
                  <span style={{ marginTop: "-15px", marginLeft: "15px", fontSize: "smaller" }}><a target='_blank' href={local_routes.sendresetpasswordemail}>Forgot your password?</a></span>
                </Row>
                :
                <Row>
                  <span style={{ marginTop: "-15px", marginLeft: "15px", fontSize: "smaller" }}>&nbsp;</span>
                </Row>
              }
              <Row className="">
                <Col>
                  <Button type="submit" style={{ marginTop: "5px", width: "100%" }} className="modal_button">{tab_messaging[tab_choice].button_text}</Button>
                </Col>
              </Row>
              </fieldset>
              </Form>
            </Col>
            <Col className="align-self-center" xs="12" sm="5">
            { loading &&
                <ActivityIndicator theme="button-Status-Loader" />
            }
              <Row className="d-none d-sm-block mt-4" >
                <Col>
                </Col>
              </Row>
              <Row style={!loading ? {} : { display: 'none' }}>
                <Col
                  onClick={() => setLoading(true)}
                >
                  <Facebook
                      stopLoading={() => setLoading(false)}
                  />
                </Col>
              </Row>
              <Row className="mt-2" style={!loading ? {} : { display: 'none' }}>
                <Col
                  onClick={() => setLoading(true)}
                >
                  <Google
                      stopLoading={() => setLoading(false)}
                  />
                </Col>
              </Row>
              <Row className="mt-2" style={!loading ? {} : { display: 'none' }}>
                <Col
                  onClick={() => setLoading(true)}
                >
                  <Twitter
                      callbackUrl="/login"
                  />
                </Col>
              </Row>
              <Row className="mt-2" style={!loading ? {} : { display: 'none' }} >
                <Col
                  onClick={() => setLoading(true)}
                >
                  <LinkedIn
                    stopLoading={() => setLoading(false)}
                  />
                </Col>
              </Row>
            </Col>
            
          </Row>
          <Row>
            <Col>
              {message}
            </Col>
          </Row>
          <Row className="">
            <span style={{ marginTop: "5px", marginLeft: "15px", marginRight: "15px", fontSize: "smaller" }}>By clicking above, I agree to the <a target='_blank' href="/termsofuse">Terms of Use</a> and have read the <a target='_blank' href="/privacypolicy">Privacy Statement</a>.</span>
          </Row>
        </Container>
      </Modal.Body>
      <Modal.Footer>
        <Button className="modal_button_white" onClick={props.onHide}>Maybe Later</Button>
      </Modal.Footer>
    </Modal>
  );
}

export default SignupModal;